import { request } from '@/common/request';

/**
 * @description: 分页查询联合病房MDT团队列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-11 13:41:48
 */
export const httpUnionwardTeamList = (params: any) => {
  return request.post<any, any>('/unionward/team/list', params);
};

/**
 * @description: 联合病房MDT团队详情
 * @author: KaifengLi
 * @param {any} teamId
 * @version: v2.22.0
 * @Date: 2024-09-11 15:55:30
 */
export const httpUnionwardTeamDetail = (id: string) => {
  return request.post<any, any>('/unionward/team/detail', { id });
};

/**
 * @description: 修改联合病房MDT团队
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-11 13:40:53
 */
export const httpUnionwardTeamUpdate = (params: any) => {
  return request.post<any, any>('/unionward/team/update', params);
};

/**
 * @description: 删除联合病房MDT团队
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-11 13:42:48
 */
export const httpUnionwardTeamDelete = (params: any) => {
  return request.post<any, any>('/unionward/team/delete', params);
};

/**
 * @description: 新增联合病房MDT团队以及成员
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-11 13:47:22
 */
export const httpUnionwardTeamAdd = (params: any) => {
  return request.post<any, any>('/unionward/team/add', params);
};

/**
 * @description: 修改联合病房MDT团队成员
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-11 13:46:41
 */
export const httpUnionwardTeamMemberUpdate = (params: any) => {
  return request.post<any, any>('/unionward/teamMember/update', params);
};

/**
 * @description: 删除联合病房MDT团队成员
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-11 13:46:29
 */
export const httpUnionwardTeamMemberDelete = (params: any) => {
  return request.post<any, any>('/unionward/teamMember/delete', params);
};

/**
 * @description: 新增联合病房MDT团队成员
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-11 13:46:17
 */
export const httpUnionwardTeamMemberAdd = (params: any) => {
  return request.post<any, any>('/unionward/teamMember/add', params);
};

export const httpEditTeamMember = (params: any) => {
  return request.post<any, any>('/unionward/team/editTeamMembers', params);
};

/**
 * @description: 联合病房MDT团队病例列表分页查询
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-12 10:43:05
 */
export const httpUnionwardTeamPatiets = (params: any) => {
  return request.post<any, any>('/unionward/team/teamPatietsListPage', params);
};

/**
 * @description: MDT团队病例列表分页查询
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-12 10:43:05
 */
export const httpMdtTeamPatiets = (params: any) => {
  return request.post<any, any>('/mdt/pageTeamPatient', params);
};

/**
 * @description: 联合会诊分页列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-12 14:15:27
 */
export const httpUnionwardConsultaList = (params: any) => {
  return request.post<any, any>('/unionward/consultation/listPage', params);
};

/**
 * @description: 按时间范围查询是否存在会诊，返回日期列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-12 16:28:15
 */
export const httpUnionwardConsultaTime = (params: any) => {
  return request.post<any, any>('/unionward/consultation/listConsultationCountGroupByTime', params);
};

/**
 * @description: 联合会诊详情
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-13 09:28:09
 */
export const httpUnionwardConsultaDetail = (params: any) => {
  return request.post<any, any>('/unionward/consultation/detail', params);
};

/**
 * @description: 新增联合病房MTD会诊
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-13 17:11:38
 */
export const httpUnionwardConsultaCreate = (params: any) => {
  return request.post<any, any>('/unionward/consultation/add', params);
};

/**
 * @description: 查询团队成员列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-13 15:53:44
 */
export const httpUnionwardTeamMembers = (params: any) => {
  return request.post<any, any>('/unionward/team/listTeamMembers', params);
};

/**
 * @description: 联合病房MDT团队病例列表 - 患者列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-13 16:22:21
 */
export const httpUnionwardTeamPatient = (params: any) => {
  return request.post<any, any>('/unionward/team/teamPatietsList', params);
};

/**
 * @description: 联合病房会诊添加患者
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-14 09:18:42
 */
export const httpUnionwardConsultatAddPatient = (params: any) => {
  return request.post<any, any>('/unionward/consultation/addPatients', params);
};

/**
 * @description: 联合病房会诊添加成员医生
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-14 09:19:11
 */
export const httpUnionwardConsultatAddDoctor = (params: any) => {
  return request.post<any, any>('/unionward/consultation/addDoctors', params);
};

/**
 * @description: 会诊回复列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-14 17:42:26
 */
export const httpUnionwardConsultatReplyList = (params: any) => {
  return request.post<any, any>('/unionward/zhMdtConsultationReply/list', params);
};

/**
 * @description: 新增会诊回复
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-14 17:48:01
 */
export const httpUnionwardConsultatReply = (params: any) => {
  return request.post<any, any>('/unionward/zhMdtConsultationReply/add', params);
};

/**
 * @description: 查询患者联合病房会诊列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-15 11:05:57
 */
export const httpUnionwardConsultatByPatientIds = (params: any) => {
  return request.post<any, any>('/unionward/consultation/listByPatientId', params);
};

/**
 * @description: 分页查询MDT团队列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2024-09-24 17:20:20
 */
export const httpUnionwardTeamListPage = (params: any) => {
  return request.post<any, any>('/unionward/team/listPage', params);
};

/**
 * @description: 分页查询注册申请列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2025-05-22 18:08:23
 */
export const httpUnionwardRegistrationList = (params: any) => {
  return request.post<any, any>('/doctorRegistrationApply/page', params);
};

/**
 * @description: 注册申请审核
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2025-05-22 18:08:23
 */
export const httpUnionwardRegistrationAudit = (params: any) => {
  return request.post<any, any>('/doctorRegistrationApply/audit', params);
};

/**
 * @description: 查询注册申请详情
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.22.0
 * @Date: 2025-05-22 18:08:23
 */
export const httpUnionwardRegistrationDetail = (params: any) => {
  return request.post<any, any>('/doctorRegistrationApply/detail', params);
};

/** ------------------- 质控评分 --------------------- */

/**
 * @description: 质控评分 - 确认评分
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.23.0
 * @Date: 2024-09-26 09:34:49
 */
export const httpPatientScoreConfirm = (params: any) => {
  return request.post<any, any>('/patientScore/confirm', params);
};

/**
 * @description: 质控评分 - 开始计算评分
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.23.0
 * @Date: 2024-09-26 09:36:01
 */
export const httpPatientScoreStart = (params: any) => {
  // @ts-ignore
  return request.post<any, any>('/patientScore/start', params, { hiddenErrorMsg: true });
};

/**
 * @description: 质控评分 - 患者病历评分详情
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.23.0
 * @Date: 2024-09-26 09:36:42
 */
export const httpPatientScoreDetail = (params: any) => {
  return request.post<any, any>('/patientScore/detail', params);
};

/**
 * @description: 质控评分 - 查询患者评分状态
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.23.0
 * @Date: 2024-09-26 09:37:17
 */
export const httpPatientScoreRatingStatus = (params: any) => {
  return request.post<any, any>('/patientScore/getRatingStatus', params);
};

/**
 * @description: 保存时间轴
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-15 11:28:02
 */
export const httpTimeLineLectureNoteSave = (params: any) => {
  return request.post<any, any>('/timeLineLectureNotes/save', params);
};

/**
 * @description: 获取时间轴讲稿详情
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-15 11:28:48
 */
export const httpTimeLineLectureNoteDetail = (params: any) => {
  return request.post<any, any>('/timeLineLectureNotes/detail', params);
};

/**
 * @description: 单个-入院记录详情
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:55:27
 */
export const httpMedicalGetOne = (params: any) => {
  return request.post<any, any>('/medical/getOne', params);
};

/**
 * @description: 单个-查询出院记录成功
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:56:26
 */
export const httpHospitalDischargeDetail = (params: any) => {
  return request.post<any, any>('/hospital/discharge/detail', params);
};

/**
 * @description: 单个-影像报告详情-
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:57:24
 */
export const httpImagesGetOne = (params: any) => {
  return request.post<any, any>('/images/getOne', params);
};

/**
 * @description: 单个-手术记录详情-
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:57:24
 */
export const httpSurgicalGetOne = (params: any) => {
  return request.post<any, any>('/surgical/getOne', params);
};

/**
 * @description: 单个-病理报告详情-
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:57:24
 */
export const httpPathologyGetOne = (params: any) => {
  return request.post<any, any>('/pathology/getOne', params);
};

/**
 * @description: 单个-检验报告详情-
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:57:24
 */
export const httpInspectionGetOne = (params: any) => {
  return request.post<any, any>('/inspection/getOne', params);
};

/**
 * @description: 单个-基因检测详情-
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:57:24
 */
export const httpGeneticTestingGetOne = (params: any) => {
  return request.post<any, any>('/geneticTesting/getOne', params);
};

/**
 * @description: 单个-用药记录详情-
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:57:24
 */
export const httpDrugRecordsGetOne = (params: any) => {
  return request.post<any, any>('/drugRecords/getOne', params);
};

/**
 * @description: 单个-其他资料详情-
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.24.0
 * @Date: 2024-10-18 11:57:24
 */
export const httpOtherInfoDetail = (params: any) => {
  return request.post<any, any>('/other/information/detail', params);
};

/**
 * @description: 查询病历点评列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-24 19:07:43
 */
export const httpRecordCommentsList = (params: any) => {
  return request.post<any, any>('/zhMedicalRecordComments/list', params);
};

/**
 * @description: 新增病历点评
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-24 19:08:49
 */
export const httpRecordCommentsAdd = (params: any) => {
  return request.post<any, any>('/zhMedicalRecordComments/add', params);
};

/**
 * @description: 删除病例点评
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-24 19:30:47
 */
export const httpRecordCommentsDelete = (params: any) => {
  return request.post<any, any>('/zhMedicalRecordComments/delete', params);
};

/**
 * @description: 分页查询病历更新记录
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-24 19:14:10
 */
export const httpRecordUpdatePage = (params: any) => {
  return request.post<any, any>('/zhMedicalRecordUpdate/page', params);
};

/**
 * @description: 查询标签树
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-25 11:44:56
 */
export const httpLabelsTree = (params: any) => {
  return request.post<any, any>('/labels/tree', params);
};

/**
 * @description: 查询组织病种标签树
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-25 16:43:55
 */
export const httpLabelsTreeByOrg = (params: any) => {
  return request.post<any, any>('/labels/treeByOrg', params);
};

/**
 * @description: 批量修改标签
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-27 15:28:15
 */
export const httpLabelsUpdateBatch = (params: any) => {
  return request.post<any, any>('/labels/updateBatch', params);
};

/**
 * @description: 保存患者标签
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-27 15:27:36
 */
export const httpPatientLabelSave = (params: any) => {
  return request.post<any, any>('/patientLabel/save', params);
};

/**
 * @description: 查询患者绑定标签编号
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-27 15:59:40
 */
export const httpPatientLabelBindList = (params: any) => {
  return request.post<any, any>('/patientLabel/bindList', params);
};

/**
 * @description: 标签同名查询
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.25.0
 * @Date: 2024-10-30 19:19:17
 */
export const httpLabelsListByName = (params: any) => {
  return request.post<any, any>('/labels/listByName', params);
};

/**
 * @description: 分页查询图片智能识别任务列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.27.2
 * @Date: 2024-12-13 17:02:33
 */
export const httpImageRecognitionListPage = (params: any) => {
  return request.post<any, any>('/imageRecognition/listPage', params);
};

/**
 * @description: 图片智能识别任务评价
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.27.2
 * @Date: 2024-12-13 17:03:25
 */
export const httpImageRecognitionEvaluating = (params: any) => {
  return request.post<any, any>('/imageRecognition/evaluating', params);
};

/**
 * @description: 保存图片任务提醒配置
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.27.2
 * @Date: 2024-12-17 14:58:26
 */
export const httpImageTaskRemindConfigSave = (params: any) => {
  return request.post<any, any>('/imageTaskRemindConfig/save', params);
};

/**
 * @description: 查询图片任务提醒配置列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.27.2
 * @Date: 2024-12-17 14:58:04
 */
export const httpImageTaskRemindConfigList = () => {
  return request.post<any, any>('/imageTaskRemindConfig/list', {});
};

/**
 * @description: 图片智能识别任务详情查询
 * @author: KaifengLi
 * @version: v2.27.2
 * @Date: 2024-12-18 09:50:46
 */
export const httpImageRecognitionDetail = (params: any) => {
  return request.post<any, any>('/imageRecognition/detail', params);
};

/**
 * @description: 删除智能识别任务
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.27.2
 * @Date: 2024-12-25 17:04:08
 */
export const httpImageRecognitionDelete = (params: any) => {
  return request.post<any, any>('/imageRecognition/delete', params);
};

/**
 * @description: 更新智能解析任务项的分类结果
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.27.2
 * @Date: 2024-12-19 19:06:32
 */
export const httpImageRecognUpdateClassify = (params: any) => {
  return request.post<any, any>('/imageRecognition/updateItemClassifyResult', params, {
    // @ts-ignore
    hiddenErrorMsg: true,
  });
};

/**
 * @description: 更新智能解析任务项的脱敏结果
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.27.2
 * @Date: 2024-12-19 19:08:13
 */
export const httpImageRecognUpdateMask = (params: any) => {
  return request.post<any, any>('/imageRecognition/updateItemMaskResult', params, {
    // @ts-ignore
    hiddenErrorMsg: true,
  });
};

/**
 * @description: 上传会诊录音文件
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2025-04-22 21:39:04
 */
export const httpUploadConsultRecordAudioFile = (params: any) => {
  return request.post<any, any>('/consultation/uploadConsultationRecordAudioFile', params, {
    // @ts-ignore
    hiddenErrorMsg: true,
  });
};

/**
 * @description: 查询会诊录音文件列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2025-04-22 21:40:50
 */
export const httpUploadConsultAudioFileList = (params: any) => {
  return request.post<any, any>('/consultation/listConsultationRecordAudioFile', params, {
    // @ts-ignore
    hiddenErrorMsg: true,
  });
};

/**
 * @description: 保存会诊会议参会专家姓名
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2025-04-23 10:00:00 // 请根据实际情况修改日期
 */
export const httpSaveConsultationTcSpeakers = (params: any) => {
  return request.post<any, any>('/consultation/saveConsultationTcSpeakers', params);
};

/**
 * @description: 创建生成会诊会议纪要任务
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2024-06-13 15:30:00
 */
export const httpCreateConsultationMeetingSummaryTask = (params: any) => {
  return request.post<any, any>('/consultation/createConsultationMeetingSummaryTask', params);
};

/**
 * @description: 查询生成会诊会议纪要任务详情
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2024-06-13 15:30:00
 */
export const httpConsultationMeetingSummaryTaskDetail = (params: any) => {
  return request.post<any, any>('/consultation/consultationMeetingSummaryTaskDetail', params);
};

/**
 * @description: 导出会诊会议参会专家姓名
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2025-12-08 20:33:00
 */
export const httpConsultationParticipantsExport = (params?: any) => {
  return request.post<any, any>('/consultation/participants/export', params, {
    responseType: 'blob', // 设置响应类型为blob以支持文件下载
    // @ts-ignore
    isFile: true,
  });
};

/**
 * @description: 保存会诊会议纪要
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2024-06-13 15:30:00
 */
export const httpSaveConsultationMeetingSummary = (params: any) => {
  return request.post<any, any>('/consultation/saveConsultationMeetingSummary', params);
};

/**
 * @description: 删除会诊录音文件
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2024-06-13 15:30:00
 */
export const httpDeleteConsultationRecordAudioFile = (params: any) => {
  return request.post<any, any>('/consultation/deleteConsultationRecordAudioFile', params);
};

/**
 * @description: 查询会诊会议纪要列表
 * @author: KaifengLi
 * @param {any} params
 * @version: v2.33.0
 * @Date: 2024-06-13 15:30:00
 */
export const httpQueryConsultationMeetingSummary = (params: any) => {
  return request.post<any, any>('/consultation/queryConsultationMeetingSummary', params);
};

/**
 * 生成患者时间轴
 * @param params 请求参数
 */
export const httpGeneratePatientTimeline = (params: any) => {
  return request.post<any, any>('/patient/timeline/generate', params);
};

/**
 * 恢复到上一版本
 * @param params 请求参数
 */
export const httpRestorePatientTimeline = (params: any) => {
  return request.post<any, any>('/patient/timeline/version/restore/previous', params);
};

/**
 * 恢复到指定版本
 * @param params 请求参数
 */
export const httpRestorePatientTimelineToVersion = (params: any) => {
  return request.post<any, any>('/patient/timeline/version/restore', params);
};

/**
 * 获取患者时间轴版本历史
 * @param params 请求参数
 */
export const httpGetPatientTimelineVersionHistory = (params: any) => {
  return request.post<any, any>('/patient/timeline/version/history', params);
};

/**
 * 获取患者最新时间轴
 * @param params 请求参数
 */
export const httpGetLatestPatientTimeline = (params: any) => {
  return request.post<any, any>('/patient/timeline/info', params);
};

/**
 * 更新患者时间轴
 * @param params 请求参数
 */
export const httpUpdatePatientTimeline = (params: any) => {
  return request.post<any, any>('/patient/timeline/update', params);
};

/**
 * @description: 获取NCCN指南推荐
 * @param {any} patientId 患者ID
 * @version: v2.35.0
 * @Date: 2024-06-15 14:30:00
 */
export const httpGetNCCNGuideline = (patientId?: string) => {
  return request.get<any, any>(`/ai-advisor/guideline/recommendation?patientId=${patientId}`);
};

/**
 * @description: 获取当前项目配置的NCCN指南名称列表
 * @version: v2.35.0
 * @Date: 2024-06-15 14:30:00
 */
export const httpGetProjectGuideline = () => {
  return request.get<any, any>('/project/guideline');
};

/**
 * @description: 获取治疗方案推荐（流式输出）
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2024-06-15 14:35:00
 */
export const httpGetTreatmentRecommendation = (params: any) => {
  return request.post<any, any>('/ai-advisor/treatment/recommendation', params);
};

/**
 * @description: 获取当前登录用户对指定患者的最新治疗推荐
 * @param {string} patientId 患者ID
 * @version: v2.35.0
 * @Date: 2024-06-15 14:40:00
 */
export const httpGetLatestTreatmentRecommendation = (patientId: string) => {
  return request.get<any, any>(`/ai-advisor/treatment/lastest?patientId=${patientId}`);
};

/**
 * @description: 获取病例智能洞察结果（流式输出）
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2024-06-15 14:45:00
 */
export const httpGetMedicalInsight = (params: any) => {
  return request.post<any, any>('/ai-advisor/medical/insight/qa', params);
};

/**
 * @description: 查询病例智能洞察历史记录
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2024-06-15 14:50:00
 */
export const httpGetMedicalInsightHistory = (params: any) => {
  return request.post<any, any>('/ai-advisor/medical/insight/history', params);
};

/**
 * @description: 创建病历智能会话
 * @author: KaifengLi
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2024-06-15 15:00:00
 */
export const httpCreateMedicalInsight = (params: any) => {
  return request.post<any, any>('/ai-advisor/medical/insight', params);
};

/**
 * @description: 病例问题推荐
 * @author: KaifengLi
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2024-06-15 15:05:00
 */
export const httpGetMedicalInsightQuestion = (params: any) => {
  return request.post<any, any>('/ai-advisor/medical/insight/question', params);
};

/**
 * @description: 查询表单记录列表（分页）
 * @author: KaifengLi
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2025-08-20 15:05:00
 */
export const httpPatientFormExportPage = (params: any) => {
  return request.post<any, any>('/patient/form/page', params);
};

/**
 * @description: 导出表单记录
 * @author: KaifengLi
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2025-08-20 15:05:00
 */
export const httpPatientFormExport = (params: any) => {
  return request.post<any, any>('/patient/form/export', params, {
    responseType: 'blob', // 设置响应类型为blob以支持文件下载
    // @ts-ignore
    isFile: true,
  });
};

/** @description: 查询会诊会议参会信息
 * @author: KaifengLi
 * @param {any} params 请求参数
 * @version: v2.35.0
 * @Date: 2025-12-05 13:50:00
 */
export const httpTcMeetingInfo = (params: any) => {
  return request.post<any, any>('/tcmeeting/info', params);
};
